import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/amortization-calculator',
  component: () => import('../../routes/AmortizationCalculator.svelte'),
  card: {
    id: 'amortization',
    title: 'Loan Amortization',
    description: 'See exactly how each mortgage or loan payment splits between principal and interest, with a full month-by-month payoff schedule.',
    icon: 'calendar_month',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/amortization-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Loan Amortization Calculator – Month-by-Month Payment Schedule',
    description: 'Free amortization calculator. Enter your loan details to see a complete month-by-month breakdown of principal vs. interest for any mortgage or loan.',
  },
};

export default meta;
